import Vue from "vue";
import Buefy from "buefy";
import BlogDetail from "./App.vue"


Vue.use(Buefy, {
    defaultIconPack: 'fas',
})

Vue.use(BlogDetail)

if(document.getElementById("blogPublicDetailApp")){
    new Vue({
        render:h=>h(
            BlogDetail,{
                props:{
                    blogDetail:document.getElementById("blogPublicDetailApp")
                        .getAttribute("blogDetail"),
                    prodsTags:document.getElementById("blogPublicDetailApp")
                        .getAttribute("prodsTags"),
                    blogUrl:document.getElementById("blogPublicDetailApp")
                        .getAttribute("blogUrl")
                }
            }
        )
    }).$mount("#blogPublicDetailApp")
}